var _mask, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmbarkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 98 24",
    width: 98,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 3,
    maskUnits: "userSpaceOnUse",
    width: 3,
    x: 95,
    y: 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "m95.2595 8.53809h2.262v2.28661h-2.262z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.7799 16.8712h4.7771c-.0941-1.2254-.9965-1.991-2.3885-1.991-1.3169 0-2.2011.7274-2.3886 1.991zm7.1285 1.6851h-7.1664c.1692 1.1872 1.1848 1.9721 2.6899 1.9721.9965 0 1.9938-.3444 2.5957-.9l1.3912 1.4551c-.9775 1.015-2.4636 1.6084-4.0811 1.6084-3.1415 0-5.1346-1.9336-5.1346-4.9589 0-2.9486 1.975-4.9397 4.8903-4.9397 3.3668 0 5.2286 2.2591 4.815 5.763z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.7062 16.8141v5.629h-2.5016v-5.3419c0-1.3401-.6209-2.0869-1.7305-2.0869-1.2038 0-2.012.8808-2.012 2.2209v5.2079h-2.4835v-5.3419c0-1.3401-.6201-2.0869-1.7306-2.0869-1.2038 0-2.012.8808-2.012 2.2209v5.2079h-2.5016v-9.4585h2.1631l.1692 1.1107c.6208-.8232 1.5613-1.302 2.652-1.302 1.2788 0 2.3323.5934 2.8962 1.5701.734-1.0343 1.8247-1.5701 3.2547-1.5701 2.3695 0 3.8366 1.5125 3.8366 4.0208z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.563 17.7151c0-1.5893-1.0536-2.7189-2.5396-2.7189-1.5044 0-2.5578 1.1296-2.5578 2.7189 0 1.5894 1.0534 2.719 2.5578 2.719 1.486 0 2.5396-1.1296 2.5396-2.719zm2.4826 0c0 2.9105-1.8436 4.9399-4.5145 4.9399-1.335 0-2.4637-.4787-3.2158-1.3595l-.1693 1.1489h-2.1631v-13.40287h2.5016v4.90167c.7522-.7467 1.8247-1.1679 3.0466-1.1679 2.6709 0 4.5145 2.0298 4.5145 4.9398z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.9071 17.7124c0-1.5893-1.0526-2.7189-2.5578-2.7189-1.4861 0-2.5388 1.1296-2.5388 2.7189 0 1.5894 1.0527 2.719 2.5388 2.719 1.5052 0 2.5578-1.1296 2.5578-2.719zm2.4835-4.7291v9.4584h-2.1631l-.1693-1.1489c-.7712.8808-1.8998 1.3595-3.2166 1.3595-2.671 0-4.5137-2.0294-4.5137-4.9399 0-2.9099 1.8427-4.9398 4.5137-4.9398 1.3168 0 2.4636.4788 3.2166 1.3401l.1693-1.1294z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.1509 13.6549-1.0906 1.9722c-.5268-.3641-.9776-.4981-1.5042-.4981-1.3731 0-2.2574.9766-2.2574 2.6995v4.6146h-2.5016v-9.4585h2.1631l.2064 1.1871c.715-.9765 1.5992-1.3784 2.6148-1.3784.8652 0 1.7676.2871 2.3695.8616z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.1192 22.4444-3.3289-4.0208v4.0208h-2.4827v-13.40287h2.4827v7.75447l2.9903-3.8102h2.9343l-3.6302 4.5188 4.195 4.9398z",
    fill: "#000"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m96.4654 9.38055h-.2207v.24874h.2207c.0867 0 .1418-.04823.1418-.12843 0-.06417-.0473-.12031-.1418-.12031zm.2206.46529.2287.39306h-.339l-.1892-.35285h-.1418v.35285h-.2995v-1.13115h.528c.2601 0 .4334.16041.4334.39311 0 .15239-.0866.28082-.2206.34498zm.5044-.16041c0-.5055-.3152-.83444-.8039-.83444s-.796.32894-.796.83444c0 .49737.3073.82627.796.82627s.8039-.3289.8039-.82627zm.3311 0c0 .68197-.4571 1.13927-1.135 1.13927-.6778 0-1.127-.4573-1.127-1.13927 0-.68997.4492-1.14734 1.127-1.14734.6779 0 1.135.45737 1.135 1.14734z",
    fill: "#000",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m19.1005 9.80134c.0338-.06874.0833-.12676.1434-.16863.06-.04198.1306-.06833.2059-.07604l6.7043-.53717-.2883-3.729-6.7042.53706c-.0756.00448-.1495-.01042-.2152-.04219-.0659-.03229-.1236-.08124-.1675-.14384l-3.809-5.64153-3.0286 2.11876 3.8091 5.64163c.0418.06406.0658.13677.0716.21072.0057.07417-.0069.14948-.0383.21937l-2.3333 4.97982c-.0339.0684-.0833.1263-.1434.1683s-.1307.0683-.2061.076l-5.40253.4328c-.07531.0044-.14908-.0104-.21488-.0423-.06589-.0322-.12391-.0812-.16781-.1437l-3.80869-5.64164-3.028474 2.11884 3.808694 5.6417c.04175.064.0661.1367.07183.2106.00573.0742-.00716.1495-.03827.2197l-2.89515 6.1788 3.31672 1.6106 2.89495-6.1788c.03376-.0688.08359-.1264.14366-.1687.06006-.0419.13077-.0684.20577-.076l5.40248-.4329c.0756-.0043.1494.0104.2152.0424.0661.0318.1239.0808.1678.1435l3.8091 5.6419 3.0285-2.119-3.8091-5.6415c-.0418-.0644-.0661-.1369-.0719-.211-.0057-.074.0072-.1496.0386-.2195z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbarkLogo);
export default __webpack_public_path__ + "static/media/embark-logo.c3e61fdc0d073c00582d058c57e32166.svg";
export { ForwardRef as ReactComponent };